import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@mui/material';
import { getPlaylists } from '../../services/playlists.service';

const Playlists = ({
  id,
  name,
  label,
  defaultValue,
  multiple,
  disabled,
  onChange,
  sx,
  error,
  parentPlaylist,
  firstLevelPlaylist,
}) => {
  const selectedValue = defaultValue || (multiple ? [] : null);

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState(selectedValue);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    let params = '';
    if (parentPlaylist) {
      params += '?playlistLevel=2';
    } else if (firstLevelPlaylist) {
      params += '?playlistLevel=1';
    }
    getPlaylists(params)
      .then((res) => {
        setOptions(
          parentPlaylist
            ? [{ id: 0, name: 'No Parent' }, ...res.data]
            : res.data
        );
        setLoading(false);
      })
      .catch(() => {
        // upon error, show loading only
      });
  }, []);

  return (
    <Autocomplete
      id={id}
      name={name}
      options={options}
      getOptionLabel={(option) =>
        `${
          option?.uniqueName
            ? `${option.name} - ${option?.uniqueName}`
            : `${option.name}`
        }`
      }
      sx={sx}
      value={value}
      onChange={(e, v) => {
        setValue(v);
        onChange(v);
      }}
      inputValue={inputValue}
      onInputChange={(e, v) => {
        setInputValue(v);
      }}
      multiple={multiple}
      disabled={disabled}
      loading={loading}
      isOptionEqualToValue={(op, vl) => op.id === vl.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error !== ''}
          helperText={error}
          variant="filled"
        />
      )}
    />
  );
};

Playlists.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
  parentPlaylist: PropTypes.bool,
  firstLevelPlaylist: PropTypes.bool,
};
Playlists.defaultProps = {
  multiple: false,
  disabled: false,
  sx: {},
  defaultValue: null,
  error: '',
  parentPlaylist: false,
  firstLevelPlaylist: false,
};

export default Playlists;
